import { render, staticRenderFns } from "./profileDropdownOption.vue?vue&type=template&id=b22eba4c&scoped=true"
import script from "./profileDropdownOption.vue?vue&type=script&lang=js"
export * from "./profileDropdownOption.vue?vue&type=script&lang=js"
import style0 from "./profileDropdownOption.vue?vue&type=style&index=0&id=b22eba4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22eba4c",
  null
  
)

export default component.exports